/**
 * @generated SignedSource<<5abb596c0f9129fea5e145b64b1ae001>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type DayOfWeek = "SUN" | "MON" | "TUE" | "WED" | "THU" | "FRI" | "SUT" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PopupGroupDeliverDayOfWeeks_popupGroup$data = {
  readonly startDate: string | null;
  readonly endDate: string | null;
  readonly deliverDayOfWeeks: ReadonlyArray<{
    readonly weekOfMonth: number | null;
    readonly daysOfWeek: ReadonlyArray<DayOfWeek>;
  }>;
  readonly schedules: ReadonlyArray<{
    readonly id: string;
    readonly startTime: string | null;
    readonly endTime: string | null;
  }>;
  readonly " $fragmentType": "PopupGroupDeliverDayOfWeeks_popupGroup";
};
export type PopupGroupDeliverDayOfWeeks_popupGroup = PopupGroupDeliverDayOfWeeks_popupGroup$data;
export type PopupGroupDeliverDayOfWeeks_popupGroup$key = {
  readonly " $data"?: PopupGroupDeliverDayOfWeeks_popupGroup$data;
  readonly " $fragmentSpreads": FragmentRefs<"PopupGroupDeliverDayOfWeeks_popupGroup">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PopupGroupDeliverDayOfWeeks_popupGroup",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DeliverDayOfWeek",
      "kind": "LinkedField",
      "name": "deliverDayOfWeeks",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "weekOfMonth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "daysOfWeek",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Schedule",
      "kind": "LinkedField",
      "name": "schedules",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endTime",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PopupGroup",
  "abstractKey": null
};

(node as any).hash = "87769fae2a404fb961336a7d7e6dedb2";

export default node;
